/*
 * Copyright (c) 2024, King Living
 * ReviewSection Theme Styles
 * Left-panel gallery + view-details wrapper.
 * Key: 'ReviewSection' (used by ReviewSection component via useMultiStyleConfig).
 * View-details styles live in `view-details.js`.
 */

const ReviewSection = {
  parts: ['root', 'galleryWrapper', 'stack'],

  baseStyle: {
    root: {
      alignItems: 'stretch',
      display: 'flex',
      flexDirection: 'column',
      flex: {base: 'initial', lg: 1},
      minHeight: {base: 0, lg: 0},
      overflow: {base: 'visible', lg: 'auto'},
      overflowY: {base: 'visible', lg: 'auto'},
      paddingBottom: {base: 0, lg: 5},
      sx: {
        WebkitOverflowScrolling: {lg: 'touch'},
      },
    },
    galleryWrapper: {},
    stack: {
      alignItems: 'stretch',
      gap: 8,
      width: '100%',
    },
  },
};

export default ReviewSection;
